import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import "./Index.css";
import { refreshZoneListScrollTop, searchZoneListView } from "../../../../actions/ZoneAction";
import SearchResultItem from "./SearchResultItem";
import { ListView } from "antd-mobile";
import { FuzzySearchType } from "../../../../Enums";
import * as ReactDOM from "react-dom";
import { CACHE_SESSION_USER } from '../../../../../../constants/Profile';

function MyBody(props) {
    const { pagination } = props;
    return (
        <div className="am-list-body my-body">
            <div className="zone-total">
                共{pagination.recordSum ? pagination.recordSum : 0}个项目
            </div>
            {props.children}
        </div>
    );
}

class SearchResult extends Component {

    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            formatMessage: this.props.intl['formatMessage'],
            height: document.documentElement.clientHeight,
            page: 1
        }
    }
    componentDidMount() {
        let zoneListDiv = document.getElementsByClassName('zone-list-container')[0];

        if (this.props.listScrollTop) {
            const scrollTop = this.props.listScrollTop ? this.props.listScrollTop : 0;

            // 设置滚动条的位置
            ReactDOM.findDOMNode(zoneListDiv).scrollTo({ top: scrollTop });
            this.props.dispatch(refreshZoneListScrollTop(0));
        }


    }
    _handleRecordListViewScrollTop() {
        // 经过审查元素找到滚动条的盒子元素类

        const scrollTop = document.getElementsByClassName('zone-list-container')[0].scrollTop;
        console.log(scrollTop)
        this.props.dispatch(refreshZoneListScrollTop(scrollTop));

    }
    _onEndReached(event) {
        // console.log(event)
        const page = this.state.page + 1;
        const zoneList = Object.assign([], this.props.zoneList);
        const searchCondition = Object.assign({}, this.props.searchCondition);
        searchCondition["currentPage"] = page;
        console.log(searchCondition)
        this.props.dispatch(searchZoneListView(searchCondition, zoneList, this.props.zoneCoordinateMap, this.state.formatMessage, true));
        this.setState({ page: page });
    }

    renderEmptyMessage() {
        return (<div className="zone-list-empty-message">
            <div className="zone-list-empty-message-content">
                找不到您输入的 品牌/子市场-乡镇/地址
                <br /><br />
                <strong>若想查询某个品牌</strong>
                <br />请输入品牌名称，如 普洛斯 或 宝湾；<br />
                <strong>若想查询某个地址</strong>
                <br />请输入具体道路名称，如 大叶公路 或 松蒸公路；<br />
                <strong>若想查询某个子市场-乡镇</strong>
                <br />请输入乡镇名称，如 重固镇 或 花桥镇 或 麻涌镇<br />

                <br /></div>
        </div>)
    }

    loginHandle() {
        // this.props.router.navigate('/login');
        this.props.router.navigate({
            pathname: `/login`,
            search: `?redirect=${encodeURIComponent(window.location.pathname)}`,
        })
    }

    tip() {
        let [type, count] = this.props.limit.split('_')
        const user = JSON.parse(localStorage.getItem(CACHE_SESSION_USER)) || {}
        let isLogin = !!(user && user.id)
        let authStatus = this.props.authStatus
        return (
            <>
                <div className='tipWrap'>
                    <div>
                        搜索次数已达上限
                    </div>
                    <div>
                        当前
                        {!isLogin && '未登录'}
                        {authStatus ? '已认证' : '未认证'}
                        ，搜索次数已达上限 ({count}次/天)
                    </div>
                    <div>
                        {!isLogin && '登录后'}
                        {isLogin && !authStatus && '电脑端访问，认证后'}，可使用更多搜索次数
                    </div>
                    {!isLogin && (
                        <div
                            onClick={() => { this.loginHandle() }}
                        >
                            登录/注册
                        </div>
                    )}
                </div>
            </>
        )
    }

    render() {
        const zoneList = this.props.zoneList ? this.props.zoneList : [];
        const searchCondition = this.props.searchCondition ? this.props.searchCondition : {};
        let { zonesCountByCondition, cityName, pagination } = this.props;

        let summaryMessage = "";
        let footMessage = "若想查看更多项目，请用电脑浏览器\r\n访问www.ixuanzhi.com";
        if (pagination.recordSum > 0 && searchCondition.searchFuzzyType && searchCondition.searchFuzzyType !== "") {
            let message1 = "当前共 " + (pagination.recordSum ? pagination.recordSum : 0) + " 在租仓库资源";


            if (searchCondition.searchFuzzyType === FuzzySearchType.Enums.Brand) {
                summaryMessage = message1 + " ，该品牌在" + cityName + "共" + zonesCountByCondition + "个项目";
            }
            else if (searchCondition.searchFuzzyType === FuzzySearchType.Enums.Town) {
                summaryMessage = message1 + " ，该子市场(乡镇) 共" + zonesCountByCondition + "个项目";
            }
            else if (searchCondition.searchFuzzyType === FuzzySearchType.Enums.Address) {
                summaryMessage = message1 + " ，该地址 共" + zonesCountByCondition + "个项目";
            }
            else if (searchCondition.searchFuzzyType === FuzzySearchType.Enums.Location) {

                if (zonesCountByCondition && searchCondition.mapSearchRange) {
                    summaryMessage = message1 + " ，该目标位置周边" + searchCondition.mapSearchRange + "KM" +
                        " 共" + zonesCountByCondition + "个项目";

                }
            }
        }
        let resultParts;

        let limit = this.props.limit
        if (limit) {
            return <div className="zone-list-container">
                {this.tip()}
            </div>
        }

        if (zoneList.length === 0) {
            resultParts = this.renderEmptyMessage();
        } else {
            resultParts =
                (<div>
                    {summaryMessage !== '' ? <div className="list-message">{summaryMessage}</div> : null}
                    <div className="zone-list">{
                        zoneList.map((zone, index) => {
                            return <SearchResultItem
                                viewPositionFunction={() => this._handleRecordListViewScrollTop()}
                                key={index} zone={zone} {...this.props} />
                        })
                    }</div>
                </div>)
        }
        return (<div className="zone-list-container">
            {resultParts}
            <div className="list-message">若想查看更多项目，请用电脑浏览器<br />访问www.ixuanzhi.com</div>
        </div>);
    }


}

function mapStateToProps(store) {
    return {
        cityName: store.WMSZoneReducer.cityName,
        zoneList: store.WMSZoneReducer.zoneList,
        searchCondition: store.WMSZoneReducer.searchCondition,
        pagination: store.WMSZoneReducer.pagination,
        isLoading: store.WMSZoneReducer.isLoading,
        zonesCountByCondition: store.WMSZoneReducer.zonesCountByCondition,
        zoneCoordinateMap: store.WMSZoneReducer.zoneCoordinateMap,
        listScrollTop: store.WMSZoneReducer.listScrollTop,
        limit: store.WMSZoneReducer.limit,
        temporaryVipStatus: store.UserReducer.temporaryVipStatus,
        authStatus: store.UserReducer.authStatus,
    }
}

export default connect(mapStateToProps)(injectIntl(SearchResult));